import { Typography } from '@cmg/design-system';
import { FormattedNumber } from '@cmg/i18n';
import { Fragment, VFC } from 'react';

type Props = {
  readonly currencyCode: string;
  readonly rangeLow?: number | null;
  readonly rangeHigh?: number | null;
};

export const CurrencyRangeValue: VFC<Props> = props => {
  const { currencyCode, rangeLow: priceRangeLow, rangeHigh: priceRangeHigh } = props;

  return (
    <Typography variant="highlight2" color="text.primary" role="cell">
      <Fragment>
        {!!priceRangeLow && (
          <FormattedNumber value={priceRangeLow} format="currency" currency={currencyCode} />
        )}
        <span> - </span>
        {!!priceRangeHigh && (
          <FormattedNumber value={priceRangeHigh} format="currency" currency={currencyCode} />
        )}
      </Fragment>
    </Typography>
  );
};
